import { useUpdateMutationFactory, UseUpdateMutationProps } from '@/lib/react-query/update';
import { Inspection, InspectionLog } from '@/types';
import { post } from '@/utils/api';
import { featureKeys, featurePath } from '.';

export type CompleteInspectionLogDTO = { inspection: Inspection; log: InspectionLog };

const completeInspection = ({ inspection, log }: CompleteInspectionLogDTO) =>
  post<InspectionLog>(`${featurePath(inspection)}/${log.id}/complete`, {});

export const useCompleteInspection = (options?: UseUpdateMutationProps<InspectionLog>) => {
  return useUpdateMutationFactory({
    invalidateKeys: featureKeys,
    mutationFn: completeInspection,
    ...options,
  });
};
